<template>
  <div v-if="user?.role === 'Pemrakarsa'" class="chat-wrapper">
    <div :class="['chat-container', isChatOpen ? 'd-block' : 'd-none']">
      <div class="chat-title">Helpdesk Pengendalian</div>
      <div class="chat-body">
        <div v-for="d in dataChat" :class="['message', d.id_pengirim == user.id ? 'from-user' : 'from-admin']">
          {{ d.isi_chat }}
          <span class="chat-time">{{ formatDate(d.createdAt, 'HH.mm') }}</span>
        </div>
      </div>
      <div class="chat-input">
        <input type="text" v-model="chatText" placeholder="Ketik pesan atau pertanyaan Anda..." />
        <button @click="sendChat" :disabled="!chatText || isLodingSend">
          <Loader v-if="isLodingSend" />
          <PaperPlane v-else />
        </button>
      </div>
    </div>
    <img @click="toggleChat" :src="supportAgent" alt="live-chat" class="btn-chat" id="chatToggle" />
  </div>
</template>

<script>
import supportAgent from '@/assets/support-agent.png'
import PaperPlane from '../Icons/PaperPlane.vue'
import Loader from '../Loader/Loader'
import axios from 'axios'
import { formatDate } from '../../helper/helpernew'
import Swal from 'sweetalert2'

export default {
  components: { PaperPlane, Loader },
  data() {
    return {
      supportAgent,
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || {}),
      isChatOpen: false,
      isLodingSend: false,
      chatText: '',
      roomChatId: null,
      dataChat: [],
    }
  },
  methods: {
    formatDate,
    async loadChat() {
      if (!this.roomChatId) return
      const res = await axios.get(
        `${this.baseapiPengendalian}api/chat?sort=createdAt,ASC&limit=0&filter=id_chat_room,=,${this.roomChatId}`,
        this.getApiOption(),
      )
      this.dataChat = res.data?.data || []
    },
    async sendChat() {
      if (!this.roomChatId) {
        await this.checkRoomChat()
      }

      try {
        this.isLodingSend = true
        await axios.post(
          `${this.baseapiPengendalian}api/chat`,
          {
            id_chat_room: this.roomChatId,
            id_penerima: 1,
            isi_chat: this.chatText,
          },
          this.getApiOption(),
        )
        this.chatText = ''
        this.loadChat()
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Terjadi kesalahan saat mengirim pesan',
          icon: 'error',
        })
      } finally {
        this.isLodingSend = false
      }
    },
    async checkRoomChat() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/chat_room?filter=id_pemrakarsa,=,${this.user.id}`,
        this.getApiOption(),
      )
      const resData = res.data?.data[0]
      if (!resData) {
        const resRoom = await axios.post(
          `${this.baseapiPengendalian}api/chat_room`,
          { id_laporan: 0 },
          this.getApiOption(),
        )
        this.roomChatId = resRoom.data?.data.id || null
        return false
      } else {
        this.roomChatId = resData.id
        return true
      }
    },
    toggleChat() {
      this.isChatOpen = !this.isChatOpen
      if (this.isChatOpen) {
        this.loadChat()
      }
    },
    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
  async mounted() {
    // if (this.user.role === 'Pemrakarsa') {
    //   await this.checkRoomChat()
    //   await this.loadChat()
    // }
  },
}
</script>

<style scoped>
/* Wrapper dan tombol chat */
.chat-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

/* Tombol chat mengambang */
.btn-chat {
  background: #373737;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}
.btn-chat:hover {
  transform: scale(1.1);
}

/* Kotak obrolan */
.chat-container {
  position: absolute;
  bottom: 80px;
  right: 0;
  width: 350px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  font-family: 'Inter', sans-serif;
}

/* Judul chat */
.chat-title {
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}

/* Area isi chat */
.chat-body {
  padding: 12px;
  height: 400px;
  overflow-y: auto;
  font-size: 14px;
  /* position: relative; */
}
.day-divider {
  /* position: sticky;
  top: 0px;
  z-index: 100; */
  text-align: center;
  margin-bottom: 10px;
}
.day-divider span {
  background: #f1f1f1;
  font-size: 12px;
  padding: 2px 7px;
  border-radius: 9999px;
}
.message {
  margin-bottom: 14px;
  padding: 8px 10px;
  border-radius: 8px;
}
.from-user {
  background: #5a7dcc;
  color: #ffffff;
  text-align: right;
  margin-left: 50px;
  position: relative;
}
.from-user .chat-time {
  right: 100%;
  margin-right: 5px;
}
.from-admin {
  background: #f1f1f1;
  text-align: left;
  margin-right: 50px;
  position: relative;
}
.from-admin .chat-time {
  left: 100%;
  margin-left: 5px;
}
.chat-time {
  position: absolute;
  bottom: 0px;
  font-size: 12px;
  color: #373737;
}

/* Input area */
.chat-input {
  display: flex;
  border-top: 1px solid #ddd;
}
.chat-input input {
  flex: 1;
  border: none;
  padding: 10px;
  outline: none;
}
.chat-input button {
  background: #0078ff;
  border: none;
  color: white;
  padding: 10px 16px;
  cursor: pointer;
}
.chat-input button:hover:not([disabled]) {
  background: #005fcc;
}
.chat-input button[disabled] {
  opacity: 50%;
  cursor: default;
}

:deep(.data-loader i) {
  margin: 0px !important;
}
</style>
